import Hls from "hls.js"

let _hlsInstance: Hls | null = null

export const VideoPlayer = {
  mounted(this: any) {
    const video = this.el as HTMLVideoElement

    video.addEventListener("contextmenu", (e) => e.preventDefault())
    video.disablePictureInPicture = true

    this._applyRate(video)

    const src = video.querySelector("source")?.getAttribute("src") || ""
    const isHls = src.includes(".m3u8")

    if (isHls) {
      this._loadHls(video, src)
    }

    this.handleEvent("set_rate", ({ rate }: { rate: string }) => {
      const parsed = parseFloat(rate)
      if (!isNaN(parsed)) video.playbackRate = parsed
    })
  },

  updated(this: any) {
    this._applyRate(this.el)
  },

  destroyed(this: any) {
    if (_hlsInstance) {
      _hlsInstance.destroy()
      _hlsInstance = null
    }
  },

  _loadHls(video: HTMLVideoElement, src: string) {
    if (_hlsInstance) {
      _hlsInstance.destroy()
      _hlsInstance = null
    }

    if (Hls.isSupported()) {
      const hls = new Hls({ enableWorker: true })
      _hlsInstance = hls
      hls.loadSource(src)
      hls.attachMedia(video)
      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        video.play().catch(() => {})
      })
    } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
      // Safari — native HLS support
      video.src = src
      video.play().catch(() => {})
    }
  },

  _applyRate(video: HTMLVideoElement) {
    const rate = parseFloat(video.dataset.rate ?? "1")
    if (!isNaN(rate)) video.playbackRate = rate
  },
}
